module.exports = __webpack_public_path__ + "static/media/AH.20924e83.svg";